import { render, staticRenderFns } from "./project-filter-buttons.vue?vue&type=template&id=64a76c66&scoped=true&"
import script from "./project-filter-buttons.vue?vue&type=script&lang=ts&"
export * from "./project-filter-buttons.vue?vue&type=script&lang=ts&"
import style0 from "./project-filter-buttons.vue?vue&type=style&index=0&id=64a76c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a76c66",
  null
  
)

export default component.exports